import axios from 'axios'
import {PropsWithChildren, useEffect, useState} from 'react'

import FullPageLoader from 'catalystZeroComponents/fullPageLoader'

import UserContext, {UserContextType} from '../../context/UserContext'
import {configureRefreshTokenInterceptor} from '../../utils/interceptors'
import {savePath} from '../login-callback/LoginCallback'

import {accessToken, getUserInfo, login, refresh} from './mid-facade'

const refreshToken = () => refresh().then(configureAccessToken)

const configureAccessToken = () => {
  axios.defaults.headers.common = {Authorization: `Bearer ${accessToken()}`}
}

const configureInterceptors = () => {
  configureRefreshTokenInterceptor(refreshToken)
}

const enrichUserWithPicture = (userInfo: UserContextType) => {
  if (userInfo) {
    // @ts-expect-error fmno has not been defined as property, but is returned from okta
    userInfo.picture = `https://profiles.intranet.mckinsey.com/person/fmno_photos/${userInfo.fmno}/medium.jpg`
  }
  return userInfo
}

const LoginProvider = ({children}: PropsWithChildren) => {
  const [isUserAuthenticated, setIsUserAuthenticated] = useState(false)
  const [currentUser, setCurrentUser] = useState<UserContextType>(null)

  useEffect(() => {
    savePath()
    login()
      .then(configureAccessToken)
      .then(configureInterceptors)
      .then(getUserInfo)
      .then(enrichUserWithPicture)
      .then(setCurrentUser)
      .then(() => setIsUserAuthenticated(true))
      .catch(() => setIsUserAuthenticated(false))
  }, [])

  return (
    <UserContext.Provider value={currentUser}>
      {isUserAuthenticated && children}
      {!isUserAuthenticated && <FullPageLoader />}
    </UserContext.Provider>
  )
}

export default LoginProvider
